const cfg = {
  // Must be configured in back (DataProviders/Forum/Post::POSTS_PER_PAGE
  // and in front (src-sites/forum/const-config/limitCountPost
  limitCountPost: 20,
  limitCountClubs: 10,
  limitCountClubList: 5,
  limitCountUserClubs: 10,
  limitCountTags: 25,
  limitCountForumTopics: 25,
  limitCountSearch: 25
};

export default cfg;
